import { render } from "./AmountSelector.vue?vue&type=template&id=8a994a94&scoped=true"
import script from "./AmountSelector.vue?vue&type=script&lang=js"
export * from "./AmountSelector.vue?vue&type=script&lang=js"

import "./AmountSelector.vue?vue&type=style&index=0&id=8a994a94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a994a94"]])

export default __exports__